var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.165 12.407c0 6.627 5.373 12 12 12 6.625-.008 11.993-5.376 12-12 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12zm1.978-.004C2.141 6.865 6.627 2.373 12.165 2.368v.01c5.541 0 10.035 4.488 10.04 10.029-.003 5.538-4.494 10.025-10.032 10.024-5.538-.001-10.028-4.49-10.03-10.028z",
    fill: "#33BB40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.203 7.007a2.241 2.241 0 01-2.231 2.241h-5.835a1.942 1.942 0 00-1.939 1.933.146.146 0 01-.146.144.144.144 0 01-.143-.144V9.093a2.241 2.241 0 012.24-2.24h7.91a.144.144 0 01.144.154z",
    fill: "#70CE45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.395 10.782h-6.258a2.241 2.241 0 00-2.241 2.232v2.088c0 .08.064.144.143.144.08 0 .145-.064.146-.144a1.943 1.943 0 011.942-1.942h4.182a2.241 2.241 0 002.242-2.232.146.146 0 00-.156-.146z",
    fill: "#33BB40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.735 14.702h-4.598a2.241 2.241 0 00-2.241 2.241v2.077a.144.144 0 00.143.146c.08 0 .146-.066.146-.146a1.942 1.942 0 011.942-1.94h2.52a2.241 2.241 0 002.241-2.242.146.146 0 00-.153-.136z",
    fill: "#229F43"
  })));
};

export default SvgLogo;